import { Link as RouterLink } from "react-router-dom";
import {
  Link,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import StyledTable from "components/StyledTable";
import { TimeEntry } from "models/TimeEntry";
import AbsenceTypeChip from "components/AbsenceTypeChip";
import { useAuthContext } from "features/auth/AuthContext";
import AbsenceStateIcon from "components/AbsenceStateIcon";

type AbsenceTableProps = {
  entries: TimeEntry[];
  sortBy: keyof TimeEntry;
  setSortBy: (column: keyof TimeEntry) => void;
  sortDir: "asc" | "desc";
  setSortDir: (dir: "asc" | "desc") => void;
};

const AbsenceTable: React.FC<AbsenceTableProps> = ({
  entries,
  sortBy,
  setSortBy,
  sortDir,
  setSortDir,
}) => {
  const { user } = useAuthContext();
  const isAdmin = user?.role === "ADMIN" || user?.role === "USER_ADMIN" || user?.role === "PAYROLL";

  function renderSortLabel(column: keyof TimeEntry, label: string) {
    return (
      <TableSortLabel
        active={sortBy === column}
        direction={sortBy === column ? sortDir : "asc"}
        onClick={() =>
          sortBy === column ? setSortDir(sortDir === "asc" ? "desc" : "asc") : setSortBy(column)
        }
      >
        {label}
      </TableSortLabel>
    );
  }

  return (
    <TableContainer>
      <StyledTable size="small" striped>
        <TableHead>
          <TableRow>
            <TableCell>{renderSortLabel("userName", "Medarbetare")}</TableCell>
            {isAdmin && <TableCell>{renderSortLabel("type", "Typ")}</TableCell>}
            <TableCell>{renderSortLabel("from", "Från")}</TableCell>
            <TableCell>{renderSortLabel("to", "Till")}</TableCell>
            {isAdmin && <TableCell align="right">{renderSortLabel("state", "Status")}</TableCell>}
          </TableRow>
        </TableHead>

        <TableBody>
          {!entries?.length && (
            <TableRow>
              <TableCell colSpan={100} align="center" sx={{ fontStyle: "italic" }}>
                Ingen data matchar sökningen
              </TableCell>
            </TableRow>
          )}

          {entries.map((entry) => (
            <TableRow key={entry.id}>
              <TableCell>
                <Link component={RouterLink} to={`/users/view/${entry.userId}`}>
                  {entry.userName}
                </Link>
              </TableCell>
              {isAdmin && (
                <TableCell>
                  <AbsenceTypeChip entry={entry} />
                </TableCell>
              )}
              <TableCell sx={{ fontSize: "small" }}>{entry.from}</TableCell>
              <TableCell sx={{ fontSize: "small" }}>{entry.to}</TableCell>
              {isAdmin && (
                <TableCell align="right" sx={{ width: 0 }}>
                  <AbsenceStateIcon entry={entry} />
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </StyledTable>
    </TableContainer>
  );
};

export default AbsenceTable;
